SymbolSelecter = function () {
  this._modes = [];
  this._symbolSelectionWT = undefined;
  this._currentMode = undefined;
  this._forcedSymbolSizes = [];

  this.setInjectorMode = function (injectorMode) {
    this._currentMode = injectorMode;
  };

  this.setData = function (reel, data) {
    const symbolList = data.symbols;
    for (let i = 0; i < symbolList.length; i++) {
      const sym = symbolList[i];
      if (!sym.reels.includes(reel)) {
        // Symbol cannot occur on this reel
        continue;
      }
      const modeList = sym.modes;

      for (let j = 0; j < modeList.length; j++) {
        const modeName = modeList[j];
        if (!this._modes[modeName]) {
          this._modes[modeName] = [];
        }
        let groupingWT = undefined;
        let blockSymbol = false;
        if (sym.grouping !== undefined) {
          groupingWT = new WeightedTable();
          let singleFound = false;
          for (let k = 0; k < sym.grouping.length; k++) {
            groupingWT.addOutcome(sym.grouping[k].num, sym.grouping[k].weight);
            if (sym.grouping[k].num === 1) {
              singleFound = true;
            }
          }
          if (!singleFound) {
            blockSymbol = true;
          }
        }

        let symData = {
          id: sym.id,
          weight: sym.weighting,
          active: true,
          lastSeenCount: -1,
          grouping: groupingWT,
          gapData: sym.minGap,
          blockSymbol: blockSymbol,
        };
        this._modes[modeName].push(symData);
      }
    }
    this._symbolSelectionWT = new WeightedTable();
  };

  this.pickSymbols = function (reelbandData) {
    let symList = this._modes[this._currentMode];
    this._symbolSelectionWT.clearOutcomes();
    this.updateSymbolActiveStates(reelbandData);
    for (let i = 0; i < symList.length; i++) {
      const sym = symList[i];
      if (sym.active) {
        this._symbolSelectionWT.addOutcome(sym.id, sym.weight);
      }
    }
    const symSelected = this._symbolSelectionWT.pickOutcome();

    let symCount = this.getSymbolCount(symSelected);

    for (let i = 0; i < this._forcedSymbolSizes.length; i++) {
      if (this._forcedSymbolSizes[i].id === symSelected) {
        symCount = this._forcedSymbolSizes[i].size;
      }
    }

    let symsToAdd = [];
    for (let i = 0; i < symCount; i++) {
      symsToAdd.push(symSelected);
      this.updateLastSeenCount(symSelected);
    }
    this._forcedSymbolSizes = [];
    return symsToAdd;
  };

  this.updateSymbolActiveStates = function (reelbandData) {
    let distanceData = [];
    this._forcedSymbolSizes = [];
    let gapLeft = -1;
    if (reelbandData !== undefined) {
      const bandIndex = reelbandData.index;
      const reelband = reelbandData.reelband;
      let count = 0;
      for (let i = bandIndex; i < reelband.length; i++) {
        if (reelband[i].symId === -1) {
          gapLeft++;
        } else {
          let data = {
            id: reelband[i].symId,
            gap: count,
          };
          distanceData.push(data);
        }
        count++;
      }
      if (distanceData.length) {
        gapLeft = distanceData[0].gap;
      }
    }

    const symList = this._modes[this._currentMode];
    for (let i = 0; i < symList.length; i++) {
      let sym = symList[i];
      sym.active = true;

      // Firstly, we need to check if the symbol has a grouping
      // associated with it. If it does and we've just picked that
      // symbol we need to ensure it is not picked for at least
      // one symbol to preserve the grouping.
      if (sym.grouping !== undefined) {
        if (sym.lastSeenCount === 0) {
          sym.active = false;
          continue;
        }
      }
      // Next we need to check if the symbol is within the minimum
      // gap of another symbol and disable if so
      if (sym.gapData !== undefined) {
        const gapList = sym.gapData;
        for (let j = 0; j < gapList.length; j++) {
          const gapSym = gapList[j].id;
          const gapAmount = gapList[j].gap;
          const lastSeenCount = this.getSymbolLastSeenCount(gapSym);
          if (lastSeenCount !== -1) {
            if (lastSeenCount < gapAmount) {
              sym.active = false;
              continue;
            }
          }
        }
      }
      // Also, once the results are in and have been placed on
      // the band, we need to look ahead to check none of the
      // symbol distance rules have been broken
      if (sym.gapData !== undefined && distanceData.length) {
        let symSize = 1;
        // If current symbol is a block symbol, pick the size of the
        // block now and check if it will fit in the remaining space
        if (sym.blockSymbol) {
          symSize = this.getSymbolCount(sym.id);
          if (symSize <= gapLeft) {
            const forcedSize = {
              id: sym.id,
              size: symSize,
            };
            this._forcedSymbolSizes.push(forcedSize);
          } else {
            sym.active = false;
            continue;
          }
        }
        // Next, check the required gap for the current symbol
        // with the gaps between the entire results window
        // we have previously place
        this.getActiveStateFromDistance(sym, distanceData, symSize);
      }
    }
  };

  this.getActiveStateFromDistance = function (sym, distData, symSize) {
    for (let i = 0; i < sym.gapData.length; i++) {
      const symId = sym.gapData[i].id;
      const symGap = sym.gapData[i].gap;
      for (let j = 0; j < distData.length; j++) {
        const distId = distData[j].id;
        const distGap = distData[j].gap;
        if (symId === distId && sym.id === symId) {
          if (distGap - symSize < symGap) {
            sym.active = false;
            return;
          }
        }
      }
    }
  };

  this.getSymbolCount = function (symId) {
    const symList = this._modes[this._currentMode];
    for (let i = 0; i < symList.length; i++) {
      const sym = symList[i];
      if (sym.id === symId) {
        if (sym.grouping !== undefined) {
          return sym.grouping.pickOutcome();
        }
      }
    }
    return 1;
  };

  this.updateLastSeenCount = function (symId) {
    const symList = this._modes[this._currentMode];
    for (let i = 0; i < symList.length; i++) {
      let sym = symList[i];

      if (symId == sym.id) {
        sym.lastSeenCount = 0;
      } else {
        if (sym.lastSeenCount !== -1) {
          sym.lastSeenCount++;
          if (sym.lastSeenCount > 100) {
            // Just capping at 100 to prevent potential overflow
            // errors, we won't need to check past 100
            sym.lastSeenCount = 100;
          }
        }
      }
    }
  };

  this.getSymbolLastSeenCount = function (symId) {
    const symList = this._modes[this._currentMode];
    for (let i = 0; i < symList.length; i++) {
      let sym = symList[i];
      if (sym.id === symId) {
        return sym.lastSeenCount;
      }
    }
    return -1;
  };

  this.getBlockSymbols = function () {
    let blockSymbols = [];
    const symList = this._modes[this._currentMode];
    for (let i = 0; i < symList.length; i++) {
      const sym = symList[i];
      if (sym.blockSymbol) {
        blockSymbols.push(sym.id);
      }
    }
    return blockSymbols;
  };
};
